import type { ActionMessage } from 'satcheljs';
import { networkFailureHandler } from './networkFailureHandler';
import type { LazyImport, LazyModule } from 'owa-bundling-light';
import type { OWAHandledNetworkError } from './networkFailureHandler';

/**
 * wraps the module in try/catch and shows a toast with network
 * error in case of lazy load failure
 * telemetry of network failure is handled internally by LazyImport
 *
 * @param lazyImport the action for which error handling is needed
 * @param lazyImportArgs arguments for the lazy function/action
 * @param errorMessage error string to show the user
 */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type.
 *	> Unexpected any. Specify a different type. */
export function lazyImportWithErrorHandler<TArgs extends any[], TModule extends LazyModule<any>>(
    lazyImport: LazyImport<(...args: TArgs) => ActionMessage, TModule>,
    onError?: (error: OWAHandledNetworkError) => void
) {
    return async function (...lazyImportArgs: TArgs) {
        lazyImport
            .import()
            .then(downloadedAction => downloadedAction(...lazyImportArgs))
            .catch(e => {
                networkFailureHandler(e);
                onError?.(e);
            });
    };
}
